import React from 'react';
import {Col, Row} from 'react-bootstrap';
import GeneralBlock from './general/GeneralBlock';
import BillingBlock from './general/BillingBlock';
import DailyData from './general/DailyData';
import LocationStatus from './general/LocationStatus';
import ExclusivePie from './general/ExclusivePie';
import MAUByLocationsStatus from './general/MAUByLocationsStatus';

const General = ({publisher, publisherId, isSuccess, isError, retry}) => {

  return (
    <>
      <GeneralBlock publisher={publisher} isSuccess={isSuccess} isError={isError} retry={retry} />
      <BillingBlock publisher={publisher} isSuccess={isSuccess} isError={isError} retry={retry} />
      <ExclusivePie publisherId={publisherId}/>
      <DailyData publisherId={publisherId}/>
      <Row>
        <LocationStatus publisherId={publisherId} md={5} as={Col}/>
        <MAUByLocationsStatus publisherId={publisherId} md={7} as={Col} />
      </Row>
    </>
  )
}

export default General
